const breakpoints = {
  phoneLimit: 600,
  tabletPortraitLimit: 900,
  tabletLandscapeLimit: 1200,
  DesktopLimit: 1800
}; //breakpoints

const isPhoneOnly = () => {
  return window.matchMedia(`(max-width: ${breakpoints.phoneLimit - 1}px)`)
    .matches;
}; //isPhoneOnly

const isTabletPortraitOnly = () => {
  return window.matchMedia(`(min-width: ${breakpoints.phoneLimit}px) and (max-width: ${breakpoints.tabletLandscapeLimit - 1}px)`)
    .matches;
} //isTabletPortraitOnly

const isTabletPortraitUp = () => {
  return window.matchMedia(`(min-width: ${breakpoints.phoneLimit}px)`).matches;
}; //isTabletPortraitUp

const isTabletLandscapeUp = () => {
  return window.matchMedia(`(min-width: ${breakpoints.tabletPortraitLimit}px)`)
    .matches;
}; //isTabletLandscapeUp

const isDesktopUp = () => {
  return window.matchMedia(`(min-width: ${breakpoints.tabletLandscapeLimit}px)`)
    .matches;
}; //isDesktopUp

const isBigDesktopUp = () => {
  return window.matchMedia(`(min-width: ${breakpoints.DesktopLimit}px)`)
    .matches;
}; //isBigDesktopUp

export {
  breakpoints,
  isPhoneOnly,
  isTabletPortraitOnly,
  isTabletPortraitUp,
  isTabletLandscapeUp,
  isDesktopUp,
  isBigDesktopUp
};
